export default "__VITE_ASSET__eWOFWPhH__"